import React from "react";
import { Calendar, ArrowRight } from "lucide-react";
import { Badge } from "./ui/badge";
import { news } from "../data/mock";

const News = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <Badge className="bg-brand-light text-brand hover:bg-brand-light mb-4 border-0">News & Aggiornamenti</Badge>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-brand-dark mb-4 leading-tight">
              Ultime <span className="italic text-brand">novità</span>
            </h2>
            <p className="text-lg text-brand-dark/70">Nuovi corsi, aperture iscrizioni, aggiornamenti normativi. Resta sempre informato.</p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {news.map((item) => (
            <article key={item.id} className="group bg-[#fafaf7] rounded-3xl overflow-hidden border border-emerald-100 hover:border-brand hover:shadow-xl hover:-translate-y-1 transition-all cursor-pointer">
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <Badge variant="outline" className="border-emerald-200 text-brand text-xs">{item.category}</Badge>
                  <div className="flex items-center gap-1 text-xs text-brand-dark/60">
                    <Calendar className="w-3 h-3" /> {item.date}
                  </div>
                </div>
                <h3 className="font-display text-xl font-bold text-brand-dark mb-3 leading-snug group-hover:text-brand transition-colors">{item.title}</h3>
                <p className="text-sm text-brand-dark/70 leading-relaxed mb-4">{item.excerpt}</p>
                <div className="flex items-center gap-1 text-sm font-semibold text-brand">
                  Leggi di più <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;
